(function () {
  const cacheKeyPrefix = 'pumper-upsell-price:';

  function applyRounding(price, decimalString) {
    const decimal = parseFloat(decimalString.replace('x', ''));

    if (Number.isNaN(decimal)) {
      return price;
    }

    let lowerPrice = Math.floor(price) + decimal;

    if (lowerPrice > price) {
      lowerPrice -= 1;
    }

    const upperPrice = lowerPrice + 1;
    const finalPrice =
      price - lowerPrice <= upperPrice - price
        ? lowerPrice
        : upperPrice;

    return Math.round(finalPrice * 100) / 100;
  }

  function formatMoney(price) {
    const currencyCode = window.Shopify?.currency?.active || 'USD';
    const locale = document.documentElement.lang || 'en-US';

    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode
    }).format(price);
  }

  function extractPumperOffer(html) {
    const offerMatch = html.match(
      /window\.pumper\.offer\s*=\s*(\{[\s\S]*?\});\s*window\.pumperv2/
    );

    if (!offerMatch) {
      return null;
    }

    try {
      return JSON.parse(offerMatch[1]);
    } catch (error) {
      console.warn('Pumper offer parsing failed', error);
      return null;
    }
  }

  function getDiscountedPrice(basePrice, offer) {
    const priceType = offer.price?.[0];
    const discountValue = Number(offer.discount?.[0]);

    if (!discountValue) {
      return null;
    }

    if (priceType === 'fixed') {
      return discountValue;
    }

    if (priceType === 'percentage') {
      let discountedPrice =
        basePrice * (1 - discountValue / 100);

      if (
        offer.priceRoundingStatus &&
        offer.priceRoundingType
      ) {
        discountedPrice = applyRounding(
          discountedPrice,
          offer.priceRoundingType
        );
      }

      return discountedPrice;
    }

    return null;
  }

  async function getPumperData(handle) {
    const currencyCode = window.Shopify?.currency?.active || 'USD';
    const cacheKey =
      `${cacheKeyPrefix}${currencyCode}:${handle}`;
    const cachedData = sessionStorage.getItem(cacheKey);

    if (cachedData) {
      try {
        const parsedData = JSON.parse(cachedData);

        if (Date.now() - parsedData.timestamp < 600000) {
          return parsedData;
        }
      } catch (error) {
        sessionStorage.removeItem(cacheKey);
      }
    }

    try {
      const [productHtml, productData] = await Promise.all([
        fetch(`/products/${handle}`).then((response) => {
          if (!response.ok) {
            throw new Error(`Product HTML request failed: ${response.status}`);
          }

          return response.text();
        }),
        fetch(`/products/${handle}.js`).then((response) => {
          if (!response.ok) {
            throw new Error(`Product JSON request failed: ${response.status}`);
          }

          return response.json();
        })
      ]);

      const offer = extractPumperOffer(productHtml);
      const basePrice = Number(productData.price) / 100;

      if (!offer || !basePrice) {
        return null;
      }

      const discountedPrice = getDiscountedPrice(
        basePrice,
        offer
      );

      if (discountedPrice === null) {
        return null;
      }

      const result = {
        basePrice,
        discountedPrice,
        timestamp: Date.now()
      };

      sessionStorage.setItem(
        cacheKey,
        JSON.stringify(result)
      );

      return result;
    } catch (error) {
      console.warn(
        `Pumper price fetch failed for ${handle}`,
        error
      );

      return null;
    }
  }

  function renderPrice(priceElement, basePrice, discountedPrice) {
    priceElement.innerHTML = `
      <s>${formatMoney(basePrice)}</s>
      <span class="product-upsell__price-new">
        ${formatMoney(discountedPrice)}
      </span>
    `;
  }

  function processUpsellHolders() {
    const holders = document.querySelectorAll(
      '[data-upsell-holder]:not([data-pumper-processed])'
    );

    holders.forEach(async (holder) => {
      const handle = holder.dataset.handle;
      const priceElement = holder.querySelector(
        '.product-upsell__price'
      );

      if (!handle || !priceElement) {
        return;
      }

      holder.setAttribute('data-pumper-loading', 'true');

      const priceData = await getPumperData(handle);

      holder.removeAttribute('data-pumper-loading');

      if (!priceData) {
        return;
      }

      renderPrice(
        priceElement,
        priceData.basePrice,
        priceData.discountedPrice
      );

      holder.setAttribute('data-pumper-processed', 'true');
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    processUpsellHolders();

    const cartDrawer = document.getElementById('cart-drawer');

    if (cartDrawer) {
      const observer = new MutationObserver(() => {
        processUpsellHolders();
      });

      observer.observe(cartDrawer, {
        childList: true,
        subtree: true
      });
    }
  });
})();